export const STAGE_LIMITS = {
  Quote: 7,
  Template: 5,
  Fabrication: 7,
  "Polish & QC": 3,
  Install: 5,
  Complete: null,
};

export const STAGE_DATE_FIELD = {
  Template: "template_date",
  Fabrication: "fab_date",
  Install: "install_date",
};

const daysSince = (iso) =>
  Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

export const stageSince = (job) => {
  const history = job.stage_history || [];
  const last = [...history].reverse().find((h) => h.stage === job.stage);
  return last?.at || job.updated_at || job.created_at;
};

export const daysInStage = (job) => {
  const since = stageSince(job);
  return since ? daysSince(since) : 0;
};

// The current stage's booked date, if the stage tracks one (Template / Fab / Install).
export const stageBookedDate = (job) => {
  const field = STAGE_DATE_FIELD[job.stage];
  return field ? job[field] || null : null;
};

// Days the current stage is past its booked date.
//   null -> stage has no booked date
//   0    -> booked for today or a future day (not overdue)
//   >0   -> days overdue
export const stageOverdueDays = (job) => {
  const d = stageBookedDate(job);
  if (!d) return null;
  if (new Date(d).getTime() > Date.now()) return 0;
  return daysSince(d);
};

export const isStalled = (job) => {
  if (job.deal_only) return false;
  const limit = STAGE_LIMITS[job.stage];
  if (limit == null) return false;
  const overdue = stageOverdueDays(job);
  // A stage with a booked date stalls only once it's overdue past its target —
  // one that's still booked ahead is never stalled.
  if (overdue !== null) return overdue > limit;
  return daysInStage(job) > limit;
};

export const StageAge = ({ job, testId }) => {
  const limit = STAGE_LIMITS[job.stage];
  if (limit == null) return null;
  const overdue = stageOverdueDays(job);
  const upcoming = overdue === 0; // booked for today/future
  const stalled = isStalled(job);
  const days = overdue !== null ? overdue : daysInStage(job);

  const label = stalled ? "Stalled" : upcoming ? "Booked" : "In stage";
  const title = stalled
    ? `${days} days past the booked ${job.stage} date (target ${limit}d)`
    : upcoming
      ? `${job.stage} booked for ${stageBookedDate(job)}`
      : `${days} days in ${job.stage}`;

  const dot = stalled ? "bg-red-400" : upcoming ? "bg-emerald-400" : "bg-zinc-500";
  const text = stalled
    ? "text-red-300"
    : upcoming
      ? "text-emerald-300"
      : "text-zinc-400";

  return (
    <span
      data-testid={testId}
      title={title}
      className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider ${text}`}
    >
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${dot}`} />
      {upcoming ? label : `${label} ${days}d`}
    </span>
  );
};
